export default class EmailTokenMap {
  constructor(
    public id: string,
    public ticketId: string,
    public messageId: string,
    public map: {}
  ) {}

  toString() {
    return this.id;
  }
}

export const EMAIL_TOKEN_MAP = 'email_token_maps';
export const emailTokenMapConverter = {
    toFirestore(emailTokenMap) {
      return {
        ticketId: emailTokenMap.ticketId,
        messageId: emailTokenMap.messageId,
        map: emailTokenMap.map
      }
    },

    fromFirestore(
      snapshot,
      options
    ) {
      const data = snapshot.data(options);
      return new EmailTokenMap(snapshot.id,
        data.ticketId,
        data.messageId,
        data.map
      );
    }
}